import React, { useState, ReactElement } from "react";
import { TextField, Button, Grid, Container, Typography, Card, CardActionArea, CardMedia, CardContent, Box, Tab, Tabs } from "@mui/material";
import {
    FormContainer,
    QuestionField,
    InputField,
    ButtonContainer,
    StaticFormPage,
    QuestionLabel,
    DropdownQuestion,
    NextButton,
    FormHeader,
    SelectWindow
} from "./ctepForm.styled"
import { TurnedIn } from "@mui/icons-material";


function CTEPForm(props) {
    const [appExposure, setAppExposure] = useState(true);
    const [piiData, setPiiData] = useState(true);
    const [hostingPlatform, setHostingPlatform] = useState('');
    const [cloudProvider, setCloudProvider] = useState('');
    const [premiseType, setPremiseType] = useState('');

    function handleSubmit(event) {
        event.preventDefault()
        let updatedObject = {}
        let intake_data = {}
        let continueForm = true;
        let data = {}
        for (let i = 0; i < event.target.length - 1; i++) {
            let item = event.target[i].id
            let value = event.target[i].value

            if (item === 'regulation' || item === 'securityDomains') {
                if (value === "") {
                    continueForm = false;
                    break;
                }
                value = []
                for (let j = 0; j < event.target[i].selectedOptions.length; j++) {
                    value.push(event.target[i].selectedOptions[j].value)
                }
            }

            if (item === 'on_prem_type' && premiseType === 'Other') {
                continue;

            } else if (item === 'otherPremise') {
                item = 'on_prem_type'
                intake_data = { ...intake_data, [item]: value }
            } else {
                intake_data = { ...intake_data, [item]: value }
            }
        }

        if (continueForm) {
            data = { ...updatedObject, "intake_data": intake_data }

            updatedObject = { ...updatedObject, "data": data }
            updatedObject = { ...updatedObject, "identifierFlag": "intake questionnaire" }

            props.onNextButtonClick();
            props.handlePromptSubmit(updatedObject);
        } else {
            alert("Please ensure at least one Domain and Regulation has been selected")
        }
    }

    const AppExposureChange = (event) => {
        setAppExposure(event.target.value === 'internal_application' ? false : true)
    };

    const PiiDataChange = (event) => {
        setPiiData(event.target.value === 'no' ? false : true)
    };

    const HostingPlatformChange = (event) => {
        setHostingPlatform(event.target.value)
    };

    const CloudProviderChange = (event) => {
        setCloudProvider(event.target.value)
    };

    const OnPremiseChange = (event) => {
        setPremiseType(event.target.value)
    };

    return (
        <StaticFormPage>
            <FormContainer onSubmit={handleSubmit} id="formQuestions">
                <div>
                    <FormHeader>Current cybersecurity platform</FormHeader>
                    <QuestionField>
                        <QuestionLabel>Company Name</QuestionLabel>
                        <InputField type="text" id="overview" name="overview"></InputField>
                    </QuestionField>
                    <QuestionField>
                        <QuestionLabel>Solution Name</QuestionLabel>
                        <InputField type="text" id="solname" name="solname"></InputField>
                    </QuestionField>
                    <QuestionField>
                        <QuestionLabel>Application Exposure</QuestionLabel>
                        <DropdownQuestion name="type" id="type" onChange={AppExposureChange}>
                            <option value="internet_static">Internet Facing - Static</option>
                            <option value="internet_dynamic">Internet Facing - Dynamic</option>
                            <option value="internal_application">Internal Application</option>
                        </DropdownQuestion>
                    </QuestionField>
                    {appExposure ?
                        <QuestionField>
                            <QuestionLabel>Data Sharing With External Entities</QuestionLabel>
                            <DropdownQuestion name="externalentities" id="externalentities">
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                                <option value="n/a">N/A</option>
                            </DropdownQuestion>
                        </QuestionField> : <div />
                    }
                    <QuestionField>
                        <QuestionLabel>Framework</QuestionLabel>
                        <InputField type="text" id="framework" name="framework"></InputField>
                    </QuestionField>

                    <QuestionField>
                        <QuestionLabel>Data Classification</QuestionLabel>
                        <DropdownQuestion name="classification" id="classification">
                            <option value="n-confidential">Non-Confidential</option>
                            <option value="confidential">Confidential</option>
                            <option value="internal_use">Internal Use</option>
                            <option value="public">Public</option>
                            <option value="highly_confidential">Highly Confidential</option>
                        </DropdownQuestion>
                    </QuestionField>
                    <QuestionField>
                        <QuestionLabel>PII Data</QuestionLabel>
                        <DropdownQuestion name="pii_data" id="pii_data" onChange={PiiDataChange}>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                        </DropdownQuestion>
                    </QuestionField>
                    {piiData ?
                        <QuestionField>
                            <QuestionLabel>PII Classification</QuestionLabel>
                            <DropdownQuestion name="PIIclassification" id="PIIclassification">
                                <option value="n-confidential">Non-Confidential</option>
                                <option value="confidential">Confidential</option>
                                <option value="internal_use">Internal Use</option>
                                <option value="public">Public</option>
                                <option value="highly_confidential">Highly Confidential</option>
                            </DropdownQuestion>
                        </QuestionField> : <div />
                    }
                    <QuestionField>
                        <QuestionLabel>HQ Region</QuestionLabel>
                        <DropdownQuestion name="hq_region" id="hq_region">
                            <option value="east_asia">East Asia</option>
                            <option value="SEA">SEA</option>
                            <option value="south_asia">South Asia</option>
                            <option value="oceania">Oceania</option>
                            <option value="europe">Europe</option>
                            <option value="middle East">Middle East</option>
                            <option value="africa">Africa</option>
                            <option value="NA">NA</option>
                            <option value="LATAM">LATAM</option>
                        </DropdownQuestion>
                    </QuestionField>
                    <QuestionField>
                        <QuestionLabel>ADS Region</QuestionLabel>
                        <DropdownQuestion name="ads_region" id="ads_region">
                            <option value="east_asia">East Asia</option>
                            <option value="SEA">SEA</option>
                            <option value="south_asia">South Asia</option>
                            <option value="oceania">Oceania</option>
                            <option value="europe">Europe</option>
                            <option value="middle East">Middle East</option>
                            <option value="africa">Africa</option>
                            <option value="NA">NA</option>
                            <option value="LATAM">LATAM</option>
                        </DropdownQuestion>
                    </QuestionField>
                    <QuestionField>
                        <QuestionLabel>Country</QuestionLabel>
                        <InputField type="text" id="country" name="country"></InputField>
                    </QuestionField>
                    <QuestionField>
                        <QuestionLabel>Industry</QuestionLabel>
                        <DropdownQuestion name="industry" id="industry">
                            <option value="Aerosapce_and_Defense">Aerosapce and Defense</option>
                            <option value="Automotive">Automotive</option>
                            <option value="Banking">Banking</option>
                            <option value="Capital_Markets">Capital Markets</option>
                            <option value="Chemicals">Chemicals</option>
                            <option value="Communications_and_Media">Communications and Media</option>
                            <option value="Energy">Energy</option>
                            <option value="Health">Health</option>
                            <option value="High_Tech">High Tech</option>
                            <option value="Industrial">Industrial</option>
                            <option value="Insurance">Insurance</option>
                            <option value="Life_Sciences">Life Sciences</option>
                            <option value="Natural_Resources">Natural Resources</option>
                            <option value="Public_Service">Public Service</option>
                            <option value="Private_Equity">Private Equity</option>
                            <option value="Retail">Retail</option>
                            <option value="Software_and_Platforms">Software and Platforms</option>
                            <option value="Travel">Travel</option>
                            <option value="Utilities">Utilities</option>
                            <option value="US_Federal_Government">US Federal Government</option>
                        </DropdownQuestion>
                    </QuestionField>
                    <QuestionField>
                        <QuestionLabel>Hosting Platform</QuestionLabel>
                        <DropdownQuestion name="platform" id="platform" onChange={HostingPlatformChange}>
                            <option value="IaaS">IaaS</option>
                            <option value="SaaS">SaaS</option>
                            <option value="PaaS">PaaS</option>
                            <option value="On_premises">On-premises</option>
                        </DropdownQuestion>
                    </QuestionField>
                    {hostingPlatform === 'SaaS' ?
                        <QuestionField>
                            <QuestionLabel>SaaS Provider</QuestionLabel>
                            <DropdownQuestion name="saas_provider" id="saas_provider">
                                <option value="Azure">Azure</option>
                                <option value="AWS">AWS</option>
                                <option value="GCP">GCP</option>
                                <option value="Oracle">Oracle</option>
                                <option value="Huawei">Huawei</option>
                                <option value="Others">Others</option>
                                <option value="N/A">N/A</option>
                            </DropdownQuestion>
                        </QuestionField> : <div />
                    }
                    {hostingPlatform === 'On_premises' ?
                        <QuestionField>
                            <QuestionLabel>On-premises Application Type</QuestionLabel>
                            <DropdownQuestion name="on_prem_type" id="on_prem_type" onChange={OnPremiseChange}>
                                <option value="standalone_on_premises">Standalone Application</option>
                                <option value="Client-server_application">Client-server Application</option>
                                <option value="Virtualized_application">Virtualized Application</option>
                                <option value="Containerized_application">Containerized Application</option>
                                <option value="Monolithic_application">Monolithic Application</option>
                                <option value="Microservices_based_application">Microservices Based Application</option>
                                <option value="Hybrid_applications">Hybrid Applications</option>
                                <option value="Other">Other, Please Specify</option>
                            </DropdownQuestion>
                        </QuestionField> : <div />
                    }
                    {hostingPlatform === 'On_premises' && premiseType === 'Other' ?
                        <QuestionField>
                            <QuestionLabel>Other, Please Specify</QuestionLabel>
                            <InputField type="text" id="otherPremise" name="otherPremise"></InputField>
                        </QuestionField> : <div />
                    }
                    {hostingPlatform !== 'On_premises' ?
                        <QuestionField>
                            <QuestionLabel>Cloud Provider</QuestionLabel>
                            <DropdownQuestion name="cloud_vendor" id="cloud_vendor" onChange={CloudProviderChange}>
                                <option value="Azure">Azure</option>
                                <option value="AWS">AWS</option>
                                <option value="GCP">GCP</option>
                                <option value="Oracle">Oracle</option>
                                <option value="Huawei">Huawei</option>
                                <option value="Others">Others</option>
                                <option value="N/A">N/A</option>
                            </DropdownQuestion>
                        </QuestionField> : <div />
                    }
                    {cloudProvider === 'Others' ?
                        <QuestionField>
                            <QuestionLabel>Other Cloud</QuestionLabel>
                            <DropdownQuestion name="other_cloud" id="other_cloud">
                                <option value="Azure">Azure</option>
                                <option value="AWS">AWS</option>
                                <option value="GCP">GCP</option>
                                <option value="Oracle">Oracle</option>
                                <option value="Huawei">Huawei</option>
                                <option value="Others">Others</option>
                                <option value="N/A">N/A</option>
                            </DropdownQuestion>
                        </QuestionField> : <div />
                    }
                    <QuestionField>
                        <QuestionLabel>Regulations</QuestionLabel>
                        <SelectWindow name="regulation" id="regulation" multiple>
                            <option value="AS9100 (Aerospace quality management)">AS9100 (Aerospace quality management)</option>
                            <option value="Basel III">Basel III</option>
                            <option value="CCPA (California Consumer Privacy Act)">CCPA (California Consumer Privacy Act)</option>
                            <option value="CIS v8.1">CIS v8.1</option>
                            <option value="COBIT">COBIT</option>
                            <option value="COSO v2017">COSO v2017</option>
                            <option value="CSA CCM v4">CSA CCM v4</option>
                            <option value="CSCC-1:2019">CSCC-1:2019</option>
                            <option value="DFARS (Defense Federal Acquisition Regulation Supplement)">DFARS (Defense Federal Acquisition Regulation Supplement)</option>
                            <option value="DPA">DPA</option>
                            <option value="ENISA v2.0">ENISA v2.0</option>
                            <option value="FAA Regulations">FAA Regulations</option>
                            <option value="FCC Regulations">FCC Regulations</option>
                            <option value="FDA (Food and Drug Administrations)">FDA (Food and Drug Administrations)</option>
                            <option value="FedRamp">FedRamp</option>
                            <option value="FERC(Federal Energy Regulatory Commission)">FERC(Federal Energy Regulatory Commission)</option>
                            <option value="FISMA (Federal Information Security Management Act)">FISMA (Federal Information Security Management Act)</option>
                            <option value="Freedom of Information Acts (FOIA)">Freedom of Information Acts (FOIA)</option>
                            <option value="GAPP">GAPP</option>
                            <option value="GDPR">GDPR</option>
                            <option value="GXP">GXP</option>
                            <option value="HIPAA">HIPAA</option>
                            <option value="IATF 16949">IATF 16949</option>
                            <option value="IEC 62443-4-2">IEC 62443-4-2</option>
                            <option value="IFRS">IFRS</option>
                            <option value="ISO/SAE 21434v2021">ISO/SAE 21434v2021</option>
                            <option value="ISO 10002">ISO 10002</option>
                            <option value="ISO 13485">ISO 13485</option>
                            <option value="ISO 14001">ISO 14001</option>
                            <option value="ISO 22301">ISO 22301</option>
                            <option value="ISO 26262">ISO 26262</option>
                            <option value="ISO 27001">ISO 27001</option>
                            <option value="ISO 27001:2022">ISO 27001:2022</option>
                            <option value="ISO 27017">ISO 27017</option>
                            <option value="ISO 27018">ISO 27018</option>
                            <option value="ISO 27701">ISO 27701</option>
                            <option value="ISO 29100">ISO 29100</option>
                            <option value="ISO 31000">ISO 31000</option>
                            <option value="ISO 42001">ISO 42001</option>
                            <option value="ITAR (International Traffic in Arms Regulation)">ITAR (International Traffic in Arms Regulation)</option>
                            <option value="MPA Content Security Program">MPA Content Security Program</option>
                            <option value="NAIC">NAIC</option>
                            <option value="NATO STANAGs">NATO STANAGs</option>
                            <option value="NIST 800-171">NIST 800-171</option>
                            <option value="NIST 800-37 rev2">NIST 800-37 rev2</option>
                            <option value="NIST 800-39">NIST 800-39</option>
                            <option value="NIST 800-53 rev5">NIST 800-53 rev5</option>
                            <option value="NIST 800-161 rev1">NIST 800-161 rev1</option>
                            <option value="NIST AI RMF">NIST AI RMF</option>
                            <option value="NIST CSF">NIST CSF</option>
                            <option value="NIST Privacy Framework">NIST Privacy Framework</option>
                            <option value="OHSAS 18001/ISO 45001">OHSAS 18001/ISO 45001</option>
                            <option value="OTCC">OTCC</option>
                            <option value="Other">Other</option>
                            <option value="PCI-DSS">PCI-DSS</option>
                            <option value="REACH (Registration, Evaluation, Authorization, and Restrictions of chemicals)">REACH (Registration, Evaluation, Authorization, and Restrictions of chemicals)</option>
                            <option value="SACS-002">SACS-002</option>
                            <option value="SAMA CSFv2.0">SAMA CSFv2.0</option>
                            <option value="SPARTA">SPARTA</option>
                            <option value="SWIFT CSF">SWIFT CSF</option>
                            <option value="SOC 2">SOC 2</option>
                            <option value="SOX">SOX</option>
                            <option value="Tisax">Tisax</option>
                            <option value="TSA Regulations">TSA Regulations</option>
                            <option value="TSCA (Toxic Substances Control Act)">TSCA (Toxic Substances Control Act)</option>
                            <option value="UK CAF v3.1">UK CAF v3.1</option>
                            <option value="US C2M2">US C2M2</option>
                            <option value="US CERT RMM">US CERT RMM</option>
                            <option value="US CISA">US CISA</option>
                            <option value="US CJIS">US CJIS</option>
                            <option value="US CMMC v2.0">US CMMC v2.0</option>
                            <option value="WHO GMP">WHO GMP</option>
                        </SelectWindow>
                    </QuestionField>
                    <QuestionField>
                        <QuestionLabel>User Types</QuestionLabel>
                        <DropdownQuestion name="user" id="user">
                            <option value="Workforce">Workforce</option>
                            <option value="Customers">Customers (End Users)</option>
                            <option value="Partners">Partners</option>
                            <option value="Guests">Guests</option>
                        </DropdownQuestion>
                    </QuestionField>
                    <QuestionField>
                        <QuestionLabel>User Number</QuestionLabel>
                        <InputField type="text" id="user_number" name="user_number"></InputField>
                    </QuestionField>
                    <QuestionField>
                        <QuestionLabel>Security Domains</QuestionLabel>
                        <SelectWindow name="securityDomains" id="securityDomains" multiple>
                            <option value="APPLICATION">APPLICATION</option>
                            <option value="BCM">BCM</option>
                            <option value="CLOUD">CLOUD</option>
                            <option value="CYBERDEFENSE">CYBERDEFENSE</option>
                            <option value="DATA">DATA</option>
                            <option value="ENDPOINT">ENDPOINT</option>
                            <option value="GOVERNANCE">GOVERNANCE</option>
                            <option value="IAM">IAM</option>
                            <option value="NETWORK">NETWORK</option>
                            <option value="PHYSICAL">PHYSICAL</option>
                            <option value="SECURITYTESTING">SECURITYTESTING</option>
                            <option value="SERVER">SERVER</option>
                        </SelectWindow>
                    </QuestionField>
                    <ButtonContainer>
                        <NextButton type="submit" form="formQuestions" >Continue</NextButton>
                    </ButtonContainer>
                </div>
            </FormContainer>
        </StaticFormPage>
    );
}

export default CTEPForm;